import React, { useState } from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { adminCreatePayment } from '../services/asaas';

const { FiX, FiDollarSign, FiZap, FiFileText } = FiIcons;

export default function AdminCreatePaymentModal({ user, onClose, onSuccess }) {
  const [amount, setAmount] = useState('');
  const [credits, setCredits] = useState('');
  const [description, setDescription] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      const res = await adminCreatePayment(user.id, Number(amount), Number(credits), description);
      if (res.success) {
        onSuccess(res.invoiceUrl);
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[110] flex items-center justify-center p-4">
      <motion.div 
        initial={{ opacity: 0 }} animate={{ opacity: 1 }}
        className="absolute inset-0 bg-slate-900/60 backdrop-blur-sm" onClick={onClose} 
      />
      
      <motion.div 
        initial={{ scale: 0.9, opacity: 0 }} animate={{ scale: 1, opacity: 1 }}
        className="relative w-full max-w-md bg-white rounded-[2.5rem] shadow-2xl overflow-hidden"
      >
        <form onSubmit={handleSubmit} className="p-8 space-y-6">
          <div className="flex justify-between items-center">
            <h3 className="text-xl font-black text-slate-900">Gerar Cobrança</h3>
            <button type="button" onClick={onClose} className="p-2 bg-slate-100 rounded-full text-slate-400">
              <SafeIcon icon={FiX} />
            </button>
          </div>

          <div className="bg-indigo-50 p-4 rounded-2xl flex items-center gap-3">
            <div className="w-10 h-10 bg-indigo-600 rounded-xl flex items-center justify-center text-white">
              <SafeIcon icon={FiZap} />
            </div>
            <div>
              <p className="text-xs text-indigo-600 font-bold uppercase tracking-wider">Destinatário</p>
              <p className="font-bold text-slate-900">{user.full_name || user.email}</p>
            </div>
          </div>

          <div className="space-y-4">
            <div>
              <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest ml-1">Valor (R$)</label>
              <div className="relative">
                <SafeIcon icon={FiDollarSign} className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-300" />
                <input 
                  type="number" step="0.01" required value={amount}
                  onChange={(e) => setAmount(e.target.value)}
                  placeholder="0.00"
                  className="w-full pl-10 pr-4 py-4 bg-slate-50 border-none rounded-2xl focus:ring-2 focus:ring-indigo-500 font-bold"
                />
              </div>
            </div>

            <div>
              <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest ml-1">Créditos</label>
              <div className="relative">
                <SafeIcon icon={FiZap} className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-300" />
                <input 
                  type="number" required value={credits}
                  onChange={(e) => setCredits(e.target.value)}
                  placeholder="Ex: 5"
                  className="w-full pl-10 pr-4 py-4 bg-slate-50 border-none rounded-2xl focus:ring-2 focus:ring-indigo-500 font-bold"
                />
              </div>
            </div>

            <div>
              <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest ml-1">Descrição Interna</label>
              <div className="relative">
                <SafeIcon icon={FiFileText} className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-300" />
                <input 
                  type="text" value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  placeholder="Ex: Ajuste de pacote"
                  className="w-full pl-10 pr-4 py-4 bg-slate-50 border-none rounded-2xl focus:ring-2 focus:ring-indigo-500 text-sm"
                />
              </div>
            </div>
          </div>

          {error && <p className="text-xs text-red-500 font-bold">{error}</p>}

          <button 
            type="submit" disabled={loading}
            className="w-full py-4 bg-indigo-600 text-white rounded-2xl font-black shadow-xl shadow-indigo-100 flex items-center justify-center gap-2"
          >
            {loading ? 'Gerando...' : 'Criar Link de Pagamento'}
          </button>
        </form>
      </motion.div>
    </div>
  );
}